import Vue from 'vue'

import {
  NumberKeyboard,
  Field,
  Empty,
  Dialog,
  Toast,
} from 'vant';

export default {
  useVant () {
    Vue.use(NumberKeyboard);
    Vue.use(Field);
    Vue.use(Empty);
    Vue.use(Dialog);
    // Toast.setDefaultOptions({ duration: 0 });
    // 将所有 loading Toast 设置为背景不可点击
    Toast.setDefaultOptions('loading', { forbidClick: true });
    Vue.prototype.$toast = Toast;
  }
}



// WEBPACK FOOTER //
// ./src/vant.js